import { render, staticRenderFns } from "./EdicionCertificadosPantalla.vue?vue&type=template&id=5148acc7&"
import script from "./EdicionCertificadosPantalla.vue?vue&type=script&lang=ts&"
export * from "./EdicionCertificadosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports